import { Table } from "@tanstack/react-table";
import { Flex } from "../Flex";

export const PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];

/**
 * Page count for a server-paged table. Never below 1, so an empty result or a
 * page still loading reads "1 of 1" with Next disabled, instead of "1 of -1"
 * (react-table's "unknown", which leaves Next enabled), "1 of 0" or NaN.
 */
export const pageCountFor = (count: number | undefined, pageSize: number) =>
  Math.max(1, Math.ceil((count ?? 0) / pageSize));

export const TablePagination = <T,>({ table }: { table: Table<T> }) => (
  <Flex className="pagination" justifyContent="space-between" alignItems="center">
    <Flex>
      <span>
        Rows per page &nbsp;&nbsp;
        <select
          className="pageSizeDropdown"
          value={table.getState().pagination.pageSize}
          onChange={(e) => table.setPageSize(Number(e.target.value))}
        >
          {PAGE_SIZE_OPTIONS.map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {pageSize}
            </option>
          ))}
        </select>
      </span>
    </Flex>

    <Flex>
      <span style={{ display: "flex", alignItems: "center" }}>
        {table.getState().pagination.pageIndex + 1} of {table.getPageCount()}
      </span>
      &nbsp;&nbsp;&nbsp;
      <button
        disabled={!table.getCanPreviousPage()}
        onClick={() => table.setPageIndex(0)}
      >
        &lt;&lt;
      </button>
      &nbsp;
      <button
        disabled={!table.getCanPreviousPage()}
        onClick={() => table.previousPage()}
      >
        &lt;
      </button>
      &nbsp;
      <button
        disabled={!table.getCanNextPage()}
        onClick={() => table.nextPage()}
      >
        &gt;
      </button>
      &nbsp;
      <button
        disabled={!table.getCanNextPage()}
        onClick={() => table.setPageIndex(table.getPageCount() - 1)}
      >
        &gt;&gt;
      </button>
    </Flex>
  </Flex>
);
